import firebase from 'firebase/app';

import { numberOfItemPerPage, pageSizeOption } from '../models/constants';
export class PaginationOption {
  direction: string;
  lastValue: any;
  firstValue: any;
  perPageItem: number;
  perPageItemOption: any;
  startAt: firebase.firestore.Timestamp;

  constructor(
    direction?: string,
    lastValue?: firebase.firestore.Timestamp,
    firstValue?: firebase.firestore.Timestamp,
    perPageItem?: number,
    perPageItemOption?: any,
    startAt?: firebase.firestore.Timestamp
  ) {
    this.direction = direction || null;
    this.lastValue = lastValue || null;
    this.firstValue = firstValue || null;
    this.perPageItem = perPageItem || numberOfItemPerPage;
    this.perPageItemOption = perPageItemOption || pageSizeOption;
    this.startAt = startAt || null;
  }
}

export class BookingFilterOption {
  status: number;
  lastWeekStartDate: any;
  lastWeekEndDate: any;
  searchKey: string;

  constructor(
    status?: number,
    lastWeekStartDate?: any,
    lastWeekEndDate?: any,
    searchKey?: string
  ) {
    this.status = status || null;
    this.lastWeekStartDate = lastWeekStartDate || null;
    this.lastWeekEndDate = lastWeekEndDate || null;
    this.searchKey = searchKey || null;
  }
}
